<template>
  <div class="checkbox-container" :class="[classes]">
    <div
      class="checkbox-group ga-event"
      :style="
        checkboxState
          ? color && `background-color: ${color}; border-color: ${color};`
          : null
      "
      :data-category="gacategory"
      :data-eventlabel="gatext"
      :data-eventvaluetype="gavaluetype"
      :data-eventvalue="gavalue"
      @click="toggle()"
    >
      <input
        type="checkbox"
        :id="id || uniqueId"
        :name="name"
        :value="value"
        :disabled="disabled"
        :required="required"
        :color="color"
        :checked="checkboxState"
        @change="toggle()"
      />
      <slot v-if="!checkboxState" name="image" />
      <slot v-else name="activeImage" />
      <label class="checkbox_label" :for="id || uniqueId">
        <slot />
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: "Checkbox",
  model: {
    prop: "model",
    event: "change",
  },
  props: {
    id: {
      type: String,
      default: undefined,
    },
    model: {
      type: String | Array,
      default: undefined,
    },
    checked: {
      type: Boolean,
      default: false,
      required: false,
    },
    value: {
      required: true,
      default: null,
    },
    name: String,
    required: Boolean,
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    color: String,
    image: String,
    activeImage: String,
    metaData: Object,
    gacategory: null,
    gatext: null,
    gavaluetype: null,
    gavalue: null,
    inLine: {
      type: Boolean,
      required: false,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      uniqueId: "",
    };
  },
  computed: {
    checkboxState() {
      if (this.model === undefined) {
        return this.checked;
      }

      if (Array.isArray(this.model)) {
        return this.model.indexOf(this.value) !== -1;
      }

      return this.model;
    },
    getImage() {},
    classes() {
      return {
        "checkbox-disabled": this.disabled,
        "checkbox-active": this.checkboxState,
        "checkbox-inline": this.inLine,
        "checkbox-error": this.error,
      };
    },
  },
  methods: {

    toggle() {
      if (this.disabled) return;

      let value = this.model;
      let wasInactive = !this.checkboxState;

      if (Array.isArray(value)) {
        value = value.slice();
        const i = value.indexOf(this.value);

        if (i === -1) {
          value.push(this.value);
        } else {
          value.splice(i, 1);
        }
      } else {
        value = !this.checkboxState;
      }

      this.$emit("change", value);

      // If checkbox is now active, emit clear-error event
      if (wasInactive && (Array.isArray(value) ? value.indexOf(this.value) !== -1 : value)) {
        this.$emit("clear-error");
      }
    },

    genId() {
      if (this.id === undefined || typeof String) {
        this.uniqueId = `m-checkbox--${Math.random()
          .toString(36)
          .substring(2, 10)}`;
      } else {
        this.uniqueId = this.id;
      }
    },
  },
  watch: {
    checked(newVal) {
      if (newVal !== this.checkboxState) {
        this.toggle();
      }
    },
  },
  mounted() {
    this.genId();

    if (this.checked && !this.checkboxState) {
      this.toggle();
    }
  },
};
</script>

<style lang="scss" scoped>
.checkbox-container {
  color: #2e343b;

  &.checkbox-active {
    border-radius: 4px;

    .checkbox-group {
      &:before {
        background-color: #00ab64;
        border-color: #00ab64;
      }
    }
  }

  &.checkbox-error {
    .checkbox-group {
      &:before {
        border-color: #ED2424 !important;
        background-color: #F0DADA !important;
        content: "" !important;
      }
    }
  }

  .checkbox-group {
    @apply ut-cursor-pointer ut-my-3;
    height: 100%;
    width: 100%;

    &:before {
      @apply ut-inline-block ut-text-center ut-mr-4;
      content: url("../../assets/styles/frontend-library/images/icon-check-white.svg");
      border: 1px solid #979797;
      border-radius: 3px;
      height: 18px;
      width: 38px;
      margin-top: 3px;
      vertical-align: text-top;

      @media (max-width: 650px) {
        width: 40px;
      }
    }

    label {
      @apply ut-inline-block ut-cursor-pointer;
      font-size: 16px;
      line-height: 18px;
    }

    //Hide input
    input {
      border: 0;
      clip: rect(0 0 0 0);
      height: 1px;
      margin: -1px;
      overflow: hidden;
      padding: 0;
      position: absolute;
      width: 1px;
    }
  }
}

.checkbox-inline {
  display: inline;
  div {
    display: inline;
    margin-right: 16px;
  }
}
.oth {
  .checkbox-container {
    color: #2c96ff;

    &.checkbox-active {
      .checkbox-group {
        &:before {
          background-color: #2c96ff;
          border-color: #2c96ff;
        }
      }
    }
  }
}
</style>

<docs>
### Example

```jsx
<checkbox id="property-type-ans-property-size"
          v-model="preapproved"
          :value="false"
          :gacategory="''"
          :gaaction="`Pre-approved for finance checkbox`">
          label here
    </checkbox>
```

</docs>
